import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { DumbModule } from "../dumb/dumb.module";
import { PinTableModule } from "../pin-modules/pin-table-module/pin-table.module";
import { PrimeNgModule } from "../prime-ng/prime-ng.module";
import { PipeModule } from "../shared/Pipe/pipe.module";
import { SharedModule } from "../shared/shared.module";
import { VoterSearchContainerComponent } from "./components/container/container.component";

import { NoDataFoundComponent } from "./components/no-data-found/no-data-found.component";
import { VoterSearchResultListComponent } from "./components/result-list/result-list.component";
import { GeneralComponent } from "./components/searchBy/general/general.component";
import { WildSearchComponent } from "./components/searchBy/wild-search/wild-search.component";
import { VisitorFormComponent } from "./components/visitor-form/visitor-form.component";
import { VoterSearchRoutingModule } from "./voter-search-routing.module";
// import {NgxPrintModule} from 'ngx-print';
import { VoterPrintComponent } from './components/voter-print/voter-print.component';
import { LastnameSearchComponent } from "./components/searchBy/lastname-search/lastname-search.component";
import { VoterSearchConfigComponent } from "./components/voter-search-config/voter-search-config.component";
import { BirthdateComponent } from './components/searchBy/birthdate/birthdate.component';
import { KalComponent } from './components/searchBy/kal/kal.component';
import { RatingComponent } from './components/searchBy/rating/rating.component';
import { YadiModificationComponent } from './components/searchBy/yadi-modification/yadi-modification.component';
import { VoterSearchFormComponent } from "./components/form/form.component";
import { PublicSearchHistoryComponent } from './components/public-search-history/public-search-history.component';


@NgModule({
  declarations: [
    VoterSearchContainerComponent,
    VoterSearchResultListComponent,
    VoterSearchContainerComponent,
    VoterSearchFormComponent,
    VisitorFormComponent,
    NoDataFoundComponent,
    WildSearchComponent,
    GeneralComponent,
    VoterPrintComponent,
    LastnameSearchComponent,
    VoterSearchConfigComponent,
    BirthdateComponent,
    KalComponent,
    RatingComponent,
    YadiModificationComponent,
    PublicSearchHistoryComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PrimeNgModule,
    SharedModule,
    PipeModule,
    PinTableModule,
    DumbModule,
    VoterSearchRoutingModule
    // NgxPrintModule
  ],
  exports: [
    VoterSearchContainerComponent,
    VoterSearchResultListComponent,
    VoterSearchContainerComponent,
    VisitorFormComponent,
    VoterSearchFormComponent
  ],
})
export class VoterSearchModule {}
